import React from 'react';
import { Outlet } from 'react-router';
import Header from './Header';
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar';
import useAuth from '../../hooks/context/useAuth';
import { Alert, Spin } from 'antd';
import useStore from '../../hooks/context/useStore';

export default function Layout() {
  const { loading } = useAuth();

  const { storeData, showSidebar } = useStore();

  return loading ? (
    <Spin fullscreen />
  ) : (
    <div>
      <Header />
      {storeData.id && !storeData.availability.open_now && (
        <Alert
          type="error"
          banner
          showIcon={false}
          message={`${storeData.name} is currently closed`}
          className="text-center font-semibold py-sm text-md bg-danger text-white"
        ></Alert>
      )}
      <div className="flex max-w-full">
        <main
          className="w-full p-xl pt-md ease-in-out duration-300"
          style={{ maxWidth: showSidebar ? `calc(100% - ${SIDEBAR_WIDTH})` : '100%' }}
        >
          <Outlet />
        </main>
        <Sidebar />
      </div>
    </div>
  );
}
